import React from 'react';

const TruncatedText = ({ children }) => {
  return <div className="truncated-text">{children}</div>;
};

export default TruncatedText;
